import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  donutChart: {
    height: 36,
    width: 36,
    minWidth: 36,
    margin: 0,
    position: "relative"
  },
  donutSvg: {
    width: "100%",
    height: "100%",
    transform: "rotate(-90deg)",
    borderRadius: "50%"
  },
  donutCircle: {
    fill: "#222222",
    strokeWidth: 32,
    strokeDasharray: "0 100",
    transition: "stroke-dasharray 0.5s ease",
    "&.naAlert": {
      stroke: theme.palette.primary.light,
      fill: theme.palette.primary.light
    },
    "&.nonAlert": {
      stroke: theme.palette.secondary.dark
    },
    "&.middleAlert": {
      stroke: "#eab32f"
    },
    "&.moderateAlert": {
      stroke: theme.palette.warning.main
    },
    "&.highAlert": {
      stroke: theme.palette.warning.dark
    }
  },
  donutChartCenter: {
    background: "#fff",
    borderRadius: "50%",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  donutChartCenterText: {
    fontSize: 13,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    "&.naAlert": {
      color: theme.palette.text.secondary
    }
  },
  decreasedFontSize: {
    fontSize: 11
  }
}));
